<template>
  <div
    class="treatment-add-on"
    :class="{'--selected': addOnIsSelected}"
  >
    <div class="treatment-add-on__header">
      <span class="treatment-add-on__name">{{ addOn.name }}</span>
      <span class="treatment-add-on__price">USD $20</span>
    </div>
    <div class="treatment-add-on__description">
      {{ addOn.description }}
    </div>
    <div class="treatment-add-on__action">
      <button
        v-if="addOnIsSelected"
        class="treatment-add-on__button--remove"
        @click="handleRemoveClick"
      >
        <span class="icon-close" />
      </button>
      <button
        v-else
        class="treatment-add-on__button--add"
        @click="handleAddClick"
      >
        {{ tc('spaSoft.step1.selectedTreatments.addTreatment') }}
      </button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'TreatmentAddOn',
    props: {
      addOn: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        status: false,
      }
    },
    computed: {
      ...mapGetters('i18n', ['tc']),
      addOnIsSelected() {
        return this.status
      }
    },
    methods: {
      handleAddClick() {
        this.status = true
      },
      handleRemoveClick() {
        this.status = false
      },
    }
  }
</script>
